import { PropsWithChildren } from "react";
import { cn } from "../../utils/cn";

interface BadgeProps {
  variant?: "default" | "success" | "warning" | "error" | "info";
  className?: string;
}

const variantClasses: Record<NonNullable<BadgeProps["variant"]>, string> = {
  default: "bg-slate-800/70 text-slate-100 border border-slate-700",
  success: "bg-emerald-500/20 text-emerald-200 border border-emerald-500/50",
  warning: "bg-amber-500/20 text-amber-200 border border-amber-500/50",
  error: "bg-red-500/20 text-red-200 border border-red-500/50",
  info: "bg-blue-500/20 text-blue-200 border border-blue-500/50"
};

export const Badge = ({
  children,
  variant = "default",
  className
}: PropsWithChildren<BadgeProps>) => (
  <span className={cn("inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium", variantClasses[variant], className)}>
    {children}
  </span>
);
